import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

// Components
import CartaoFicha from './CartaoFicha';

const MENSAGEM_PADRAO = "Não foi possível gerar este documento.";

export default function AvisoItemSemConteudo({ titulo, mensagem, className = "" }) {
    return (
        <CartaoFicha titulo={titulo} className={`noPrint ${className}`}>
            <div className="d-flex align-items-center gap-2 mt-3">
                <FontAwesomeIcon icon={faTriangleExclamation} className="text-warning" />
                <span>{mensagem ?? MENSAGEM_PADRAO}</span>
            </div>
        </CartaoFicha>
    );
}
